import Component from '../vendor/Component'

export default class FeaturedCtaCarousel extends Component {
  mount() {
    this.slidesContainer = this._elem.querySelector('[data-slides]')
    this.slideElements = this._elem.querySelectorAll('[data-slide]')

    if (!this.slidesContainer || this.slideElements.length < 2) return

    this.setupCarousel()
  }

  setupCarousel() {
    if (!window.swiper) return

    const initialIndexDesktop = this.slideElements.length > 2 ? 1 : 0

    this.carousel = new window.swiper(this.slidesContainer, {
      direction: 'horizontal',
      loop: false,
      initialSlide: 0,
      slidesPerView: 1.33,
      spaceBetween: -10,
      slidesPerGroup: 1,
      centeredSlides: false,
      centeredSlidesBounds: false,
      speed: 500,
      navigation: {
        nextEl: this._elem.querySelector('[data-next]'),
        prevEl: this._elem.querySelector('[data-prev]')
      },
      breakpoints: {
        451: {
          slidesPerView: 1.33
        },
        768: {
          slidesPerView: 3.2
        },
        1200: {
          slidesPerView: 3.2
        }
      }
    })
  }
}